module.exports = __webpack_public_path__ + "img/Algolia-logo.224640ca.png";